/**
 * Width of the map covered by the floating route panel on tablet/desktop,
 * in CSS px from the screen's left edge: the panel's left inset plus its
 * width. Mirrors `StationCardOrDetailsRouter.module.css .expandedSidebar`
 * (`width: min(420px, …)`, `left: max(16px, …)`) — update together if the
 * panel grows or shrinks (it was 360 wide before TASK-275).
 *
 * `desktop` must be the same reactive `matchMedia` predicate that gates the
 * panel's render (`isDesktopViewport`), never `window.innerWidth`: on iPad
 * Safari with a pinch-zoomed `visualViewport` `innerWidth` drops below the
 * breakpoint while the media query still matches, and the panel would cover
 * a station the camera thought was visible (tester iPad bug).
 *
 * Android passes the same inset (`FocusPanTarget.compute(leadingInsetPx)`);
 * iOS gets it from `UIScrollView.adjustedContentInset`.
 */
export function sidebarLeftInsetCssPx(desktop: boolean): number {
  return desktop ? SIDEBAR_LEFT_INSET_CSS_PX + SIDEBAR_WIDTH_CSS_PX : 0
}

const SIDEBAR_WIDTH_CSS_PX = 420
const SIDEBAR_LEFT_INSET_CSS_PX = 16
